import React from "react";
import { Route, Routes, createBrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { LoginPage, useAuth } from "../libs/auth";
import Shell from "../libs/shell";
import { logOut } from "../libs/auth/store/auth.slice";
import { useEffect } from "react";
import { useAppDispatch } from "../store/hooks/app-store.hook";
import Dashboard from "../feature/dashboard";
import { NotFoundPage } from "../libs/core";
import ProjectManager from "../feature/projects";
import UserManager from "../feature/users";
import BlogManager from "../feature/blogs";
import TeamProfileManager from "../feature/team";
import UnitManager from "../feature/units";
import SubscribersManager from "../feature/newsletter";
import ScheduleVisitManager from "../feature/ScheduledVisit";
import ProjectDetailPage from "../feature/projects/project-detail";
import UnitDetailsPage from "../feature/units/unit_detail";
import ProfilePage from "../feature/dashboard/profile_page";
import BlogDetailPage from "../feature/blogs/blog_details";
import TestimonialList from "../feature/testimonials";
import PartnerManager from "../feature/partners";
import UnitTypeManager from "../feature/UnitTypes";
import BankAccountManager from "../feature/BankAccount";
import ContactUsManager from "../feature/ContactUs";
import ScheduledVisitDetail from "../feature/ScheduledVisit/schedule_visit_detail";
import NewsLetterManager from "../feature/newsletter/news_letter_manager";
import NewsletterDetailPage from "../feature/newsletter/newsletter_detail";

export const Routing = (): JSX.Element => {
    /* hooks */
    const { session } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

  
    const localSession = localStorage.getItem("session");
  
    useEffect(() => {
      if (!session || !localSession) {
        dispatch(logOut());
        navigate("/login");
      } else if (session && location.pathname === "/login") {
        navigate("/");
      }
    }, [session, location.pathname, navigate, dispatch, localSession]);
  
    return (
      <>
        {/* <ScrollRestoration /> */}
        <Routes>
          {session === null && <Route path="/login" element={<LoginPage />} />}
  
          {session !== null && (
            <Route path="/" element={<>{<Shell />}</>}>
              <Route index element={<Dashboard/>}/>
              <Route path="/projects" element={<ProjectManager/>} />
              <Route path="/projects/:id" element={<ProjectDetailPage/>} />
              <Route path="/users" element={<UserManager/>} />
              <Route path="/blogs" element={<BlogManager/>} />
              <Route path="/testimonials" element={<TestimonialList/>} />
              <Route path="/teams" element={<TeamProfileManager/>} />
              <Route path="/units" element={<UnitManager/>} />
              <Route path="/subscribers" element={<SubscribersManager/>} />
              <Route path="/scheduled-visits" element={<ScheduleVisitManager/>} />
              <Route path="/profile" element={<ProfilePage/>} />
              <Route path="/units/:id" element={<UnitDetailsPage/>} />
              <Route path="/blogs/:id" element={<BlogDetailPage/>} />
              <Route path="/scheduled-visits/:id" element={<ScheduledVisitDetail/>} />
              <Route path="/partners" element={<PartnerManager/>} />
              <Route path="/unit-types" element={<UnitTypeManager/>} />
              <Route path="/bank-accounts" element={<BankAccountManager/>} />
              <Route path="/messages" element={<ContactUsManager/>} />
              <Route path="/newsletters" element={<NewsLetterManager/>} />
              <Route path="/newsletters/:id" element={<NewsletterDetailPage/>} />
            </Route>
          )}

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </>
    );
  };